import { LitElement } from 'lit';
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from '@lingui/core';
import { messages as nbMessages} from '../src/raw/stroller/locales/nb/messages.mjs';
import { messages as enMessages} from '../src/raw/stroller/locales/en/messages.mjs';
import { messages as fiMessages} from '../src/raw/stroller/locales/fi/messages.mjs';
import { messages as daMessages} from '../src/raw/stroller/locales/da/messages.mjs';
import { activateI18n } from '../src/utils/i18n';
activateI18n(enMessages, nbMessages, fiMessages, daMessages);


export class IconStroller42 extends LitElement {
  render() {
      const title = i18n.t({ message: `Stroller`, id: 'icon.title.stroller', comment: 'Title for Stroller icon' });
      
      return html`<svg xmlns="http://www.w3.org/2000/svg"width="42"height="28"fill="none"viewBox="0 0 42 28" part="w-icon-stroller-42-part">${unsafeStatic(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.25 26.188a2.437 2.437 0 1 0 0-4.875 2.437 2.437 0 0 0 0 4.875m11.375 0a2.437 2.437 0 1 0 0-4.875 2.437 2.437 0 0 0 0 4.875m1.625-8.125H13.706a1.625 1.625 0 0 1-1.576-1.231l-1.318-5.27h17.876"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m25.02 21.344 5.317-14.179a3.25 3.25 0 0 1 3.043-2.11h1.808M15.549 22.938h6.777M10.813 11.563a9.75 9.75 0 0 1 9.75-9.75v9.75m0-.001L12.14 6.648m8.422 4.915L15.648 3.14"></path></svg>`; }
}
if (!customElements.get('w-icon-stroller-42')) {
  customElements.define('w-icon-stroller-42', IconStroller42);
}